export const SET_NUMBER_OF_GUESTS_FOR_SWIMMING = 'SET_NUMBER_OF_GUESTS_FOR_SWIMMING'; // eslint-disable-line
